import BuilderModel from "../../../../common/models/tracked/builderModel";
import {
  FormApplicationStatusName,
  FormApplicationStatusType
} from "../../../../common/enums/forms/workflowSteps/formApplicationStatusType";
import Guid from "~/helpers/guid";
import CustomStatus from "../customStatus";

export default class WorkflowStepActionJumpTo extends BuilderModel {
  to_client_id: string;
  client_id: string = Guid.create();
  status: string = String(FormApplicationStatusType.completed);

  get isCollectionRoot(): boolean {
    return false;
  }

  get nextSteps() {
    return [];
  }

  statusText(form) {
    const customStatus = CustomStatus.findByReferenceOrClientId(form, String(this.status));
    return customStatus ? customStatus.name : ''
  }
}